import React from 'react';

import { StyledImageThumbnail } from './ImageThumbnail.styles';

import { ImageThumbnailProps } from './ImageThumbnail.types';

import { BackgroundImage } from '../BackgroundImage';

const ImageThumbnail = ({
  imageSrc,
  imageBackgroundSize = 'contain',
  componentClassname = 'image-thumbnail',
  customClassnames = '',
  customStyle = '',
}: ImageThumbnailProps) => {
  if (!imageSrc) return null;
  return (
    <StyledImageThumbnail
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      imageBackgroundSize={imageBackgroundSize}
    >
      <BackgroundImage
        src={imageSrc}
        className={`${componentClassname}__image`}
      />
    </StyledImageThumbnail>
  );
};
ImageThumbnail.displayName = 'ImageThumbnail';

export default ImageThumbnail;
